import { render, staticRenderFns } from "./report-form.vue?vue&type=template&id=bc74c674&scoped=true"
import script from "./report-form.vue?vue&type=script&lang=js"
export * from "./report-form.vue?vue&type=script&lang=js"
import style0 from "./report-form.vue?vue&type=style&index=0&id=bc74c674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc74c674",
  null
  
)

export default component.exports